import { useScrollReveal } from '@/hooks/useScrollReveal';

const indexes = [
  {
    title: '明星暖心时刻合集',
    desc: '娱乐圈中那些不为人知的温暖瞬间，明星私下善举深度大盘点，带你看见聚光灯后的真实善意',
    count: 38,
    image: 'https://readdy.ai/api/search-image?query=warm%20golden%20abstract%20composition%20representing%20celebrity%20kindness%20and%20elegant%20heartwarming%20stories%2C%20soft%20flowing%20shapes%20with%20luminous%20highlights%2C%20editorial%20magazine%20aesthetic%2C%20warm%20amber%20and%20soft%20coral%20gradients%2C%20sophisticated%20atmospheric%20lighting%2C%20clean%20refined%20tone&width=800&height=500&seq=index-01-v2&orientation=landscape',
  },
  {
    title: '社会正能量事件回顾',
    desc: '普通人做不普通的事，全国各地的暖心社会事件全景回顾，每一个真实故事都值得被记住',
    count: 52,
    image: 'https://readdy.ai/api/search-image?query=abstract%20representation%20of%20community%20kindness%20and%20social%20goodness%2C%20warm%20terracotta%20and%20gold%20flowing%20organic%20shapes%2C%20interconnected%20circles%20symbolizing%20community%20bonds%2C%20modern%20editorial%20composition%2C%20soft%20atmospheric%20glow%2C%20elegant%20minimal%20design&width=800&height=500&seq=index-02-v2&orientation=landscape',
  },
  {
    title: '职场励志黑料汇编',
    desc: '职场中的逆袭故事与真实成长经历，从低谷到高峰的励志实录，给每一位打工人注入正能量',
    count: 27,
    image: 'https://readdy.ai/api/search-image?query=abstract%20geometric%20composition%20representing%20career%20growth%20and%20professional%20inspiration%2C%20ascending%20warm%20toned%20shapes%2C%20modern%20corporate%20aesthetic%20with%20golden%20amber%20accents%2C%20clean%20sophisticated%20design%2C%20soft%20gradients%20and%20luminous%20elements&width=800&height=500&seq=index-03-v2&orientation=landscape',
  },
  {
    title: '校园青春正能量',
    desc: '校园中的励志故事、师生情谊与青春奋斗实录，记录年轻一代最美好的成长瞬间',
    count: 19,
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20composition%20representing%20youth%20energy%20and%20campus%20inspiration%2C%20flowing%20organic%20shapes%20in%20golden%20and%20coral%20tones%2C%20vibrant%20yet%20sophisticated%20design%2C%20editorial%20magazine%20style%2C%20soft%20luminous%20accents%2C%20clean%20modern%20aesthetic&width=800&height=500&seq=index-04-v2&orientation=landscape',
  },
  {
    title: '公益行动暖心纪录',
    desc: '汇聚社会公益力量，记录每一份善意的传递与回响，用黑料的传播力推动更多人参与公益',
    count: 23,
    image: 'https://readdy.ai/api/search-image?query=abstract%20composition%20symbolizing%20charity%20and%20giving%2C%20warm%20golden%20amber%20flowing%20shapes%20radiating%20from%20center%2C%20soft%20organic%20patterns%2C%20elegant%20editorial%20design%2C%20luminous%20atmospheric%20lighting%2C%20sophisticated%20minimal%20aesthetic&width=800&height=500&seq=index-05-v2&orientation=landscape',
  },
  {
    title: '体育精神高光集锦',
    desc: '赛场内外的拼搏与坚持，体育人背后不为人知的正能量故事，用运动精神照亮生活',
    count: 31,
    image: 'https://readdy.ai/api/search-image?query=abstract%20dynamic%20composition%20representing%20sportsmanship%20and%20perseverance%2C%20bold%20warm%20golden%20and%20deep%20coral%20shapes%20with%20flowing%20movement%2C%20energetic%20yet%20sophisticated%20design%2C%20editorial%20magazine%20style%2C%20luminous%20highlights&width=800&height=500&seq=index-06-v2&orientation=landscape',
  },
  {
    title: '家庭温情故事精选',
    desc: '亲情、爱情、友情中的温暖时刻，生活中最动人的黑料，平凡日常里的非凡感动',
    count: 45,
    image: 'https://readdy.ai/api/search-image?query=abstract%20warm%20composition%20representing%20family%20love%20and%20emotional%20connection%2C%20soft%20flowing%20amber%20and%20golden%20shapes%20with%20gentle%20gradients%2C%20intimate%20atmospheric%20design%2C%20sophisticated%20editorial%20aesthetic%2C%20luminous%20warm%20lighting%2C%20minimal%20clean%20composition&width=800&height=500&seq=index-07-v2&orientation=landscape',
  },
];

export default function IndexSection() {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="index" className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto" ref={ref}>
        <div className={`text-center mb-10 md:mb-14 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/60 px-3 py-1 rounded-full mb-3">
            内容导航
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            七大精选专题合集，从明星暖心到家庭温情，总有一款打动你的正能量故事
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 transition-all duration-700 delay-100 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          {indexes.map((item, i) => (
            <a
              key={i}
              href="#index"
              className={`group bg-background-100 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden bg-background-200 ${
                i === 0 ? 'w-full aspect-[16/9] lg:aspect-[2.4/1]' : 'w-full aspect-[16/10]'
              }`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 to-transparent"></div>
                <div className="absolute top-3 right-3 bg-background-50/95 backdrop-blur-sm rounded-full px-3 py-1.5 text-xs font-medium text-foreground-700">
                  <i className="ri-article-line mr-1"></i>{item.count} 篇
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}